export default __webpack_public_path__ + "static/media/no-photos.ebea38cf.png";